import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const baseClasses =
    'w-full h-10 mb-4 rounded-full border border-slate-200 bg-white px-4 py-3 text-base text-slate-900 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-[#3F8EE8] md:w-[21rem]';

// Password fields get a reveal toggle by default, so `type='password'` call sites need no
// change. Pass showToggle={false} to opt a password field out, or showToggle to force it on.
const AuthFormInput = ({ id, name, type = 'text', className = '', showToggle, ...rest }: any) => {
    // The four auth pages (Login, Signup, Reset ×2) all read from the `Login` namespace.
    const { t } = useTranslation(undefined, { keyPrefix: 'Login' });
    const [visible, setVisible] = useState(false);

    const withToggle = showToggle ?? type === 'password';

    if (!withToggle) {
        return <input id={id} name={name} type={type} className={`${baseClasses} ${className}`} {...rest} />;
    }

    return (
        // Matches the input's own width so the field stays aligned with its label, and
        // contains the input's bottom margin so vertical rhythm is unchanged.
        <div className='relative w-full md:w-[21rem]'>
            <input
                id={id}
                name={name}
                type={visible ? 'text' : 'password'}
                // Extra right padding keeps long values from running under the button.
                className={`${baseClasses} pr-12 ${className}`}
                {...rest}
            />
            <button
                type='button'
                onClick={() => setVisible((shown: boolean) => !shown)}
                aria-label={visible ? t('hidePassword') : t('showPassword')}
                aria-pressed={visible}
                // top-5 is half of the input's h-10, so the button centres on the field
                // rather than on the wrapper (which also spans the input's margin).
                className='absolute right-4 top-5 flex -translate-y-1/2 items-center justify-center rounded-full text-slate-400 transition hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3F8EE8]'
            >
                {visible ? <VisibilityOffIcon fontSize='small' /> : <VisibilityIcon fontSize='small' />}
            </button>
        </div>
    );
};

export default AuthFormInput;
